"use client";

import { ErrorCard } from "@/components/ui/ErrorCard";

type ErrorProps = { error: Error & { digest?: string }; reset: () => void };

export default function Error(props: ErrorProps) {
  return <ErrorCard {...props} heading="Dashboard konnte nicht geladen werden" />;
}
